module.exports = __webpack_public_path__ + "img/menu.836e24e4.svg";